import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiAttributesList, apiAttributesView } from 'Services/UserService'

export const getData = createAsyncThunk('user/attributes/getData', async datas => {
    const { data } = await apiAttributesList(datas)
    return data
})

export const getView = createAsyncThunk('user/attributes/getView', async id => {
    if (!id) return viewData
    const { data } = await apiAttributesView(id)
    return data
})

const viewData = {
    name: '',
}

export const attributesSlice = createSlice({
    name: 'user/attributes',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = attributesSlice.actions

export default attributesSlice.reducer
